import dayjs from 'dayjs'

export function formatYear(year: number, format?: string) {
    return dayjs().calendar('jalali').set('year', year).format(format)
}
